export default __webpack_public_path__ + "29bf4c910e5833e72683af27611a983c.png";